import React, { useCallback, useEffect, useState, useRef } from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import LoginIcon from '@mui/icons-material/Login';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { SCENE } from "./index";
import { grey } from "@mui/material/colors";

export default function PrescriptionMedicationGuidancePreparing(props) {
    const [device, setDevice] = useState(null);
    const videoRef = useRef(null)
    const [paused, setPaused] = useState(false);

    //  カメラ情報の更新
    const refreshDevices = useCallback(async () => {
        const latestDevices = (
            await navigator.mediaDevices.enumerateDevices()
        ).filter((d) => d.kind === "videoinput");
        setDevice(latestDevices[0])
    }, []);

    useEffect(() => {
        refreshDevices(); // カメラ情報を更新
    }, []);

    useEffect(() => {
        if (!videoRef || !device) return;
    
        navigator.mediaDevices
            .getUserMedia({
                // ここで、選択したデバイスをセット
                video: device,
            })
            .then((stream) => {
                if (!videoRef?.current) return;
                // 現在接続されているデバイスを使いストリーミング
                videoRef.current.srcObject = stream;
                setTimeout(() => {
                    if (videoRef.current) {
                        videoRef.current.play();     
                    }           
            }, 500);
        
            })
            .catch((e) => {
                console.log('getUserMedia error', e)
                props.setScene(SCENE.NOT_ALLOWED)

            });
    }, [videoRef, device]);

    const cleanupAndNext = () => {
        if (videoRef.current) {
            const stream = videoRef.current.srcObject;
            stream.getTracks().forEach(track => track.stop());
            videoRef.current.pause();
            videoRef.current.srcObject = null;
        }
        props.setScene(SCENE.WAITING)
    }
    return (
        <>
        <Grid container spacing={3} alignItems='center'>
            <Grid item xs={4}>
                <svg width="124" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 40.52">
                    <path fill="#23907a" d="m0,22.14V4.5c0-.47.14-.61.62-.61.99,0,1.98.01,2.96,0,.37,0,.49.12.49.49-.01,3.66,0,7.31-.02,10.97,0,.39.12.46.48.46,6.05-.01,12.11-.01,18.16,0,.65,0,.67.01.67.67,0,7.83,0,15.67,0,23.5,0,.37-.11.52-.51.52-7.43,0-14.86,0-22.28.02-.46,0-.56-.26-.56-.64v-17.72Zm4.08,14.52c.18,0,.31-.02.44-.02h14.37c.35,0,.45-.08.45-.44-.01-5.36-.01-10.72,0-16.07,0-.34-.08-.47-.45-.47-4.73.01-9.47.01-14.2,0-.6,0-.63.03-.63.64v15.97c0,.12.01.25.02.38"/>
                    <path fill="#23907a" d="m26.84,28.13c0-3.89,0-7.79,0-11.68,0-.64.01-.65.65-.65h22.25c.87,0,.77-.05.78.77,0,7.73,0,15.47,0,23.2,0,.71,0,.72-.71.72-6.65,0-13.31.01-19.96.01-.81,0-1.61-.01-2.42,0-.43.01-.6-.13-.59-.59.01-3.93,0-7.86,0-11.79m19.56.09h0c0-2.65,0-5.29,0-7.94,0-.53-.08-.61-.61-.61h-14.14c-.61,0-.62,0-.62.63v14.78c0,.4.06.79.04,1.19-.02.34.13.38.42.38,4.81,0,9.63,0,14.44,0,.35,0,.47-.08.47-.46-.02-2.66,0-5.31,0-7.97"/>
                    <path fill="#23907a" d="m77.1,15.8c.2.66-.29,1-.56,1.41-.51.78-1.06,1.54-1.6,2.3-.61.86-1.24,1.71-1.85,2.58-.74,1.07-1.46,2.15-2.19,3.21-.53.76-1.08,1.51-1.6,2.27-.04.09-.03.2.02.29,1.44,2.16,2.89,4.31,4.34,6.46,1.21,1.8,2.43,3.6,3.62,5.41.09.19.1.4.03.6-.02.08-.28.13-.43.14-1.1.01-2.2-.01-3.3.02-.3.02-.58-.14-.72-.4-.97-1.46-1.95-2.92-2.92-4.39-.9-1.38-1.78-2.78-2.68-4.16-.43-.65-.9-1.27-1.35-1.91-.01-.02-.02-.04-.04-.06-.57-.18-1.19-.08-1.68.26-.77,1.18-1.55,2.34-2.32,3.52-.51.78-1,1.57-1.52,2.35-.59.89-1.19,1.76-1.78,2.64-.37.55-.73,1.1-1.08,1.66-.14.31-.46.51-.8.49-1.12-.03-2.25,0-3.37-.01-.53,0-.69-.24-.41-.66.65-1.01,1.33-2,2-2.99,1.13-1.66,2.27-3.32,3.39-4.98.88-1.29,1.75-2.58,2.6-3.88.07-.14.07-.31,0-.45-.83-1.24-1.66-2.47-2.52-3.69-.89-1.26-1.8-2.5-2.69-3.75-.69-.98-1.36-1.97-2.05-2.96-.16-.2-.31-.41-.43-.64-.07-.18-.09-.38-.06-.57,0-.05.24-.1.38-.1,1.06,0,2.11.01,3.17-.01.46-.05.9.18,1.12.58.81,1.24,1.69,2.42,2.54,3.63.95,1.35,1.9,2.69,2.84,4.04.34.48.64.98,1.01,1.44.16.17.37.29.6.33.66.17,1.35-.16,1.64-.77.83-1.36,1.8-2.63,2.7-3.94,1.02-1.48,2.13-2.91,3.04-4.45.33-.61,1.01-.95,1.7-.84,1.06.01,2.12,0,3.2,0"/>
                    <path fill="#23907a" d="m96.33,33.89c0-1.9-.02-3.79.01-5.69,0-.85.07-1.7.22-2.53.5-2.65,1.89-5.05,3.93-6.82,1.38-1.25,3.04-2.15,4.84-2.62.82-.21,1.66-.29,2.5-.42.23-.03.46-.03.69,0,.1.03.18.11.2.21.01,1.4,0,2.79,0,4.19,0,.26-.1.36-.37.34-1.3-.05-2.57.32-3.65,1.04-1.13.7-2.06,1.69-2.69,2.86-.61,1.12-.93,2.37-.93,3.65,0,3.93,0,7.85,0,11.78,0,.39-.07.58-.54.56-1.19-.04-2.38-.01-3.58-.02-.5,0-.64-.15-.64-.66v-5.89"/>
                    <path fill="#23907a" d="m118.81,28.14c0,3.94,0,7.88.01,11.82,0,.43-.13.57-.54.57-1.08-.02-2.16-.01-3.23,0-.26,0-.37-.09-.36-.35,0-.23,0-.45,0-.68,0-7.63,0-15.25,0-22.88,0-1.28-.03-1.01,1.04-1.03.79-.02,1.59,0,2.38,0,.7,0,.71,0,.71.73v11.85h0Z"/>
                    <path fill="#23907a" d="m111.83,8.65c.03-1.13.57-2.18,1.46-2.87.55-.57,1.08-1.17,1.64-1.73.25-.25.61-.4.85-.65.82-.83,1.59-1.72,2.43-2.52.63-.64,1.52-.96,2.41-.85,1.39.19,2.58,1.1,3.11,2.4.49,1.08.28,2.35-.54,3.21-.73.83-1.54,1.6-2.29,2.42-.4.44-.71.98-1.1,1.43-.61.77-1.28,1.49-2.02,2.14-1.08.99-2.68,1.16-3.94.4-1.29-.62-2.08-1.95-2.02-3.38m11.77-5.03c.07-.57-.09-1.13-.46-1.57-.52-.83-1.35-1.42-2.31-1.65-.64-.17-1.32-.04-1.86.35-.96.84-1.88,1.73-2.76,2.66-.13.1-.15.28-.05.41.02.03.06.06.09.08.33.28.63.59.94.88,1.07,1.02,2.13,2.04,3.2,3.04.1.04.22.03.31-.04.7-.7,1.38-1.41,2.06-2.13.59-.5.9-1.26.83-2.03"/>
                    <path fill="#23907a" d="m86.39,26.29c1.52,0,3.04,0,4.56,0,.39,0,.56.09.55.53-.03.91,0,1.82,0,2.72,0,.63,0,.63-.65.63h-8.11c-.3,0-.59-.01-.89.01-.33.03-.46-.12-.46-.42,0-1.07.01-2.13,0-3.2,0-.29.18-.26.36-.26h4.64Z"/>
                </svg>
            </Grid>
            <Grid item xs={8}>
                <div>
                    <Typography variant="h6" component="h1" sx={{ color: '#23907A', fontWeight: 'bold'}}>
                        オンライン服薬指導
                    </Typography>
                    <Typography variant="body2" component="h6" sx={{ color: grey[700], fontWeight: 'bold'}}>
                        ベータ版
                    </Typography>
                </div>
            </Grid>
        </Grid>
        <Card sx={{mt:2}} variant="outlined">
            <div style={{height: 245, backgroundColor: '#343331', position: 'relative'}}>
                <video 
                    ref={videoRef}
                    style={{objectFit: 'cover', width: '100%', height: '100%'}}
                    muted
                    playsInline
                    onPause={()=>{setPaused(true)}}
                    onPlaying={()=>{setPaused(false)}}
                ></video>
                {paused && (
                    <Box onClick={()=>{videoRef.current.play()}} sx={{position: 'absolute', top:0, left: 0, width: '100%', height: '100%', display:'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10}}>
                        <Button variant="outlined" color="success" sx={{backgroundColor: "rgba(255,255,255,0.4)"}}>
                            <PlayArrowIcon sx={{fontSize: 40}}></PlayArrowIcon>
                        </Button>
                    </Box>
                )}
            </div>
        </Card>
        <Button variant="contained" size="large" onClick={()=>cleanupAndNext()} disableElevation sx={{ width: '100%', mt: 2, bgcolor: '#23907a', color: '#fff', fontWeight: 'bold' }} startIcon={<LoginIcon />}>服薬指導をはじめる</Button>

        </>
    );
}